import styled from "@emotion/styled";
import { palette, space } from "@stedi/dls/constants";
import { ErrorMessage } from "@stedi/dls/ErrorMessage";
import { Flex } from "@stedi/dls/Flex";
import { isJsonataEvaluationError } from "@stedi/transformers-jsonata";
import { ReadonlyPreview } from "../ReadonlyPreview";

const SOutputErrorContainer = styled(Flex)({
  position: "absolute",
  top: 0,
  left: 0,
  height: "100%",
  width: "100%",
  paddingLeft: space.s3 + space.s2,
  paddingRight: space.s3 + space.s2,
  backgroundColor: palette.gray6,
});

const SErrorMessage = styled(ErrorMessage)({
  svg: {
    display: "none",
  },
});

interface OutputEditorProps {
  value: string;
  error: Error | undefined;
}

const OutputEditor = ({ error, value }: OutputEditorProps) => {
  return (
    <>
      <ReadonlyPreview aria-label="Output" code={value} />

      {error ? (
        <SOutputErrorContainer aria-label="Output">
          <SErrorMessage>
            <ErrorMessageContent error={error} />
          </SErrorMessage>
        </SOutputErrorContainer>
      ) : null}
    </>
  );
};

export { OutputEditor };

const ErrorMessageContent = ({ error }: { error: Error }) => {
  if (!isJsonataEvaluationError(error) || error.position === undefined) {
    return <>{error.message || String(error)}</>;
  }

  return (
    <>
      {error.message} at&nbsp;position&nbsp;{error.position}
    </>
  );
};
